<div class="bs-enabled flxRow">
	<app-dropdown-c class="country-code-dropdown" style="width: 50px; --dropdown-menu-width: 220px; --bs-dropdown-overflow: auto;"
					[text]="selectedCountry ? '<i class=\'flag-icon flag-' + selectedCountry.iso2 + '\'></i>' : 'Select'" #dropdown>
		<li class="static-item" style="min-height: 0;" (click)="$event.stopPropagation()">
			<div class="search-box flxRow" style="position: relative; max-width: 300px;">
				<input type="search" class="w-100"
					   [(ngModel)]="searchCountryTxt"
					   maxlength="{{dic.CONSTANTS.maxCharsInSearch}}"
					   (keyup)="searchCountry();"
					   placeholder="Search country code">
				<a class="closeRed animated fadeIn"
				   id="clearSearchCountry"
				   (click)="searchCountryTxt = ''; searchCountry();"
				   *ngIf="searchCountryTxt"
				   style="font-size: 16px; color: #cccccc; position: absolute; right: 15px; top: calc(50% + 1px); transform: translateY(-50%);">
					<i class="zmdi zmdi-close"></i>
				</a>
			</div>
		</li>
		<div class="flex-column overflow-auto" style="max-height: 200px;">
			<li *ngFor="let country of countries | filter: {hide : '!true'}"
				(click)="selectCountryCode(country)">
				<div class="flex-row justify-content-between align-items-center gap-3">
					<div class="flex-row align-items-center gap-2">
						<i [ngClass]="'flag-icon flag-' + country.iso2"></i>
						<span>{{country.name}}</span>
					</div>
					<span class="text-muted">+{{country.dialCode}}</span>
				</div>
			</li>
			<li *ngIf="searchCountryNotFound" class="d-flex centralize py-3" (click)="$event.stopPropagation()">
				No items found
			</li>
		</div>
	</app-dropdown-c>
	<!--CC: 62px fits 4-digit dial codes ("+ 1868") - "+ 972" was clipped at 45px (QA)-->
	<input type="text" style="width: 52px; border-left: none; border-bottom-left-radius: 0; border-top-left-radius: 0; margin-left: -2px; padding-left: 2px;"
		   [readOnly]="true"
		   value="+ {{model}}"/>
</div>
